console.time("AppReady");
import {
	EventDispatcher,
	DomUtil
} from "cartovista";
import CartovistaExtend from "cartovistaExtend/CartovistaExtend";
import SaveSelection from "cartovistaExtend/mapTools/SaveSelection";
import SelectionStats from "cartovistaExtend/mapTools/SelectionStats";
import ServiceAreas from "cartovistaExtend/panels/na/ServiceAreas";
import FindRoutes from "cartovistaExtend/panels/na/FindRoutes";
import QueryCpAdrs from "cartovistaExtend/panels/QueryCpAdrs";
import AuthSessionExtend from "./AuthSessionExtend";
import DecoupagePanel from "cartovistaExtend/panels/DecoupagePanel";
import DescriptionPanel from "cartovistaExtend/panels/DescriptionPanel";
import DownloadShapefile from "cartovistaExtend/appTools/DownloadShapefile";
import DrawingControllerExtend from "cartovistaExtend/mapTools/DrawingControllerExtend";
import ReloadDataTool from "cartovistaExtend/mapTools/ReloadDataTool";
import SectorsDatastore from "./SectorsDatastore";
import {loadData, createLayers, createThemeSetsElements} from "./ServerDataHandlers";
import Capsules from "./Capsules";
import DemoSecteurs from "./DemoSecteurs";
import InfoModalExtend from "./InfoModalExtend";
import "../styles/decoupage.css";

class App extends EventDispatcher {
	constructor(cartovista) {
		super();
		this.cartovista = cartovista;
        new QueryCpAdrs();
        new ServiceAreas();
        new FindRoutes();
		window.cartovista.addOneTimeEventListener(window.cartovista.EVENTS.MAP_LOADED + "_" + C.MAP.ID, this._onCartoVistaMapLoaded, this);
		window.cartovista.addOneTimeEventListener("ServerDataInitialized", this._onServerLayersLoaded, this);
		window.cartovista.addOneTimeEventListener("StoresDataLoaded", this._onStoresDataLoaded, this);
		new AuthSessionExtend();
        new InfoModalExtend();
        window.sectorsDataStore = new SectorsDatastore();
        new DecoupagePanel();
        new DownloadShapefile();
        new DrawingControllerExtend();
        new DescriptionPanel();
        new ReloadDataTool();
        loadData();
    }

    _onCartoVistaMapLoaded() {
        this._map = window.cartovista.externalInterface.map;
        this._mapController = window.cartovista.getMapController(this._map);
        Promise.all(_.map(_.filter(this._map.layers, (layer) => layer.layerType != "TILE" ), function(layer){
            return new Promise(function(resolve, reject) {
                layer.getSimpleFeatures(null, function(result) {
                    if(result.features.length == 0){
                layer.addOneTimeEventListener(layer.EVENTS.FEATURES_ADDED, resolve);
                    } else{
                        resolve();
                    }
                });
            });
        })).then(this._onCVLayersLoaded.bind(this));
        createLayers();
        createThemeSetsElements();
        if (!DomUtil.isResponsiveUI()) {
            window.cartovista.getUIController(this._map).findInstance("dataView-selectedFeatures")._activateOnSelectionChanged = false;
            window.cartovista.resizeRightVerticalSplitter(350); 
        }
        this._map.addEventListener(this._map.EVENTS.ACTIVE_THEME_SET_CHANGED, this._onThemeSetChanged, this);
        this._loadCustomModules();
    }

    _onAllLayersLoaded(){
        console.timeEnd("AppReady");
        $("#preloader").remove();
    }

    _onServerLayersLoaded() {
        this._serverLayersLoaded = true;
        if(this._CVLayersLoaded){
            this._onAllLayersLoaded();
        }
    }

    _onCVLayersLoaded() {
        this._CVLayersLoaded = true;
        if(this._serverLayersLoaded){
            this._onAllLayersLoaded();
        }
    }

    _onStoresDataLoaded() {
        window.cartovista.addOneTimeEventListener("ServerDataInitialized", this._applyActiveThemeSet, this);
    }

    //inclure les modules custom
    _loadCustomModules() {
        new SaveSelection();
        new SelectionStats();
    }

    _applyActiveThemeSet(evt) {
        if (C.APP_TOOLS.AUTH_SESSION.USER.SELECTED_SCENARIO) {
            this._map.activeThemeSet = this._map.getThemeSet(C.APP_TOOLS.AUTH_SESSION.USER.SELECTED_SCENARIO);
        } else {
            this._map.activeThemeSet = this._map.getThemeSet(_.find(C.THEMESETS_ELEMENTS, "DEFAULT").ID);
        }
    };

    _onThemeSetChanged() {
        if (this._map.activeThemeSet && this._map.activeThemeSet.id != "PREVISIONS" && this._map.activeThemeSet.id != "TA_PP" && this._map.activeThemeSet.id != "TA_S") {
            this._map._scenarioId = this._map.activeThemeSet.id;
            var pointsLayer = this._map.getLayer(C.PANELS.DECOUPAGE_PANEL.POINTS.LAYER_ID),
                pointsLayerDatatable = pointsLayer.getDataTable(C.PANELS.DECOUPAGE_PANEL.POINTS.DATATABLE_ID);
            pointsLayer.dataViewDataColumns = pointsLayerDatatable.getDataColumns(C.LAYERS[pointsLayer.id].LAYER_PROPERTIES.DATAVIEW_DATACOLUMNS.concat(_.uniq([C.PANELS.DECOUPAGE_PANEL.POINTS.SCENARIOS_DATACOLUMNS[this._map.activeThemeSet.id].SECTOR, C.PANELS.DECOUPAGE_PANEL.POINTS.SCENARIOS_DATACOLUMNS[this._map.activeThemeSet.id].GROUP])));
            pointsLayer.dataTipDataColumns = pointsLayerDatatable.getDataColumns(C.LAYERS[pointsLayer.id].LAYER_PROPERTIES.DATATIP_DATACOLUMNS.concat(_.uniq([C.PANELS.DECOUPAGE_PANEL.POINTS.SCENARIOS_DATACOLUMNS[this._map.activeThemeSet.id].SECTOR, C.PANELS.DECOUPAGE_PANEL.POINTS.SCENARIOS_DATACOLUMNS[this._map.activeThemeSet.id].GROUP])));
            pointsLayer.infoViewDataColumns = pointsLayerDatatable.getDataColumns(C.LAYERS[pointsLayer.id].LAYER_PROPERTIES.INFOVIEW_DATACOLUMNS.concat(_.uniq([C.PANELS.DECOUPAGE_PANEL.POINTS.SCENARIOS_DATACOLUMNS[this._map.activeThemeSet.id].SECTOR, C.PANELS.DECOUPAGE_PANEL.POINTS.SCENARIOS_DATACOLUMNS[this._map.activeThemeSet.id].GROUP])));
        } else {
            this._map._scenarioId = null;
            if (this._map.activeThemeSet && this._map.activeThemeSet.id == "PREVISIONS"){
                window.cartovista.getUIController(this._map).findInstance("infoPanTool").toggleOn();
            }
        }
    }
}

$().ready(function() {
    new Capsules();
    new DemoSecteurs();
	new App(new CartovistaExtend());
});
